import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Mail, Award, Heart, Shield, Star } from 'lucide-react';
export function AboutJenny() {
  return <section id="about" className="py-24 md:py-32 bg-white px-6" data-id="element-25">
      <div className="max-w-7xl mx-auto" data-id="element-26">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-27">
          {/* Photo Side */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-28">
            <div className="relative aspect-[3/4] max-w-md mx-auto lg:mx-0" data-id="element-29">
              <img src="https://assets.cdn.filesafe.space/yOon1ID2yH9FCnnAGN2G/media/6228f759ced3001c58d1474b.png" alt="Jenny Gong - Las Vegas Luxury Realtor" className="w-full h-full object-cover" data-id="element-30" />
              {/* Gold frame accent */}
              <div className="absolute -bottom-4 -right-4 w-full h-full border border-gold -z-10" data-id="element-31"></div>
            </div>
          </motion.div>

          {/* Content Side */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-32">
            <span className="text-gold uppercase tracking-[0.2em] text-sm font-medium mb-4 block" data-id="element-33">
              Your Trusted Advisor
            </span>
            <h2 className="text-4xl md:text-5xl font-serif text-charcoal mb-3" data-id="element-34">
              About <span className="italic" data-id="element-35">Jenny Gong</span>
            </h2>
            <p className="text-gold uppercase tracking-widest text-sm mb-8" data-id="element-36">
              Licensed Las Vegas Realtor
            </p>

            <div className="space-y-5 text-charcoal-light font-light leading-relaxed text-lg mb-10" data-id="element-37">
              <p data-id="element-38">
                Jenny Gong is an experienced full-time realtor dedicated to
                helping clients find their dream homes in Las Vegas.
                Specializing in Las Vegas, Henderson, North Las Vegas, and
                surrounding communities, Jenny brings a wealth of local
                knowledge and an unwavering commitment to her clients.
              </p>
              <p data-id="element-39">
                With a positive attitude and tireless energy, Jenny goes above
                and beyond to help her clients achieve their real estate goals.
                She believes that integrity and honesty are the foundation of
                every successful relationship, and as your realtor, she is
                committed to earning your trust every step of the way.
              </p>
              <p data-id="element-40">
                Whether you're a first-time buyer searching for the perfect
                home, an investor looking for your next opportunity, or a seller
                ready to move on to your next chapter, Jenny provides the
                personalized guidance and expert market insight you deserve.
              </p>
            </div>

            {/* Values */}
            <div className="grid grid-cols-2 gap-6 mb-10" data-id="element-41">
              <div className="flex items-center gap-3" data-id="element-42">
                <div className="w-10 h-10 rounded-full border border-gold flex items-center justify-center text-gold flex-shrink-0" data-id="element-43">
                  <Shield className="w-4 h-4" data-id="element-44" />
                </div>
                <span className="text-sm text-charcoal font-medium" data-id="element-45">
                  Integrity First
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-46">
                <div className="w-10 h-10 rounded-full border border-gold flex items-center justify-center text-gold flex-shrink-0" data-id="element-47">
                  <Heart className="w-4 h-4" data-id="element-48" />
                </div>
                <span className="text-sm text-charcoal font-medium" data-id="element-49">
                  Client Dedicated
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-50">
                <div className="w-10 h-10 rounded-full border border-gold flex items-center justify-center text-gold flex-shrink-0" data-id="element-51">
                  <Award className="w-4 h-4" data-id="element-52" />
                </div>
                <span className="text-sm text-charcoal font-medium" data-id="element-53">
                  Local Expert
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-54">
                <div className="w-10 h-10 rounded-full border border-gold flex items-center justify-center text-gold flex-shrink-0" data-id="element-55">
                  <Star className="w-4 h-4" data-id="element-56" />
                </div>
                <span className="text-sm text-charcoal font-medium" data-id="element-57">
                  Results Driven
                </span>
              </div>
            </div>

            {/* Contact */}
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-58">
              <a href="tel:+18583978218" className="inline-flex items-center gap-3 bg-gold text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300" data-id="element-59">
                <Phone className="w-4 h-4" data-id="element-60" />
                (858) 397-8218
              </a>
              <a href="#contact" className="inline-flex items-center gap-3 border border-charcoal text-charcoal px-8 py-4 uppercase tracking-widest text-sm hover:bg-charcoal hover:text-white transition-colors duration-300" data-id="element-61">
                <Mail className="w-4 h-4" data-id="element-62" />
                Get in Touch
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}